<template>
  <div class="footer-wrapper">
    <div class="footer-content">
      <!-- <div class="left">
        <span class="brand">Tupperware<i class="brand-r">®</i></span>
        <span class="name">会生意·商家中心</span>
      </div> -->
      <div class="right">
        <span class="code-text" @mouseover="showQrcode" @mouseleave="hideQrcode">
          <i class="icon-erweima"></i>扫码下载会生意App
          <div class="qrcodeBox" v-show="showCode">
            <img :src="require('../assets/images/qrcode.png')" />
          </div>
        </span>
        <a href="javascript:;" @click="toPrivacy" target="_blank" :download="false">隐私政策</a>
        <!--<a class="old-s" target="_blank" href="https://fms.tupperware.com.cn/sjetstorefront/electronics-cn/zh/login" >旧系统登录</a>-->
        <!--<a target="_blank" href="https://tup-file.tupperware.com.cn/%E7%89%B9%E7%99%BE%E6%83%A0.%E5%95%86%E5%AE%B6%E4%B8%AD%E5%BF%83%EF%BC%88PC%EF%BC%89%E6%93%8D%E4%BD%9C%E6%8C%87%E5%BC%95.pdf">下载操作指引</a>-->
        <span>如有问题请发邮件至it@tupperware.com</span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      showCode: false,
    }
  },
  methods: {
    toPrivacy(){
      //console.log("--隐私政策-->：",this.$PRIVACY_POLICY_URL)
      window.open(this.$PRIVACY_POLICY_URL)
    },
    showQrcode () {
      this.showCode = true
    },
    hideQrcode () {
      this.showCode = false
    }
  }
}
</script>

<style lang="scss">
@import "~assets/style/variable";
.footer-wrapper {
  height: 50px;
  width: 100%;
  z-index: 1;
  position:fixed;
  bottom:0;
  background-color: $color-text;
  color: #667075;
  .footer-content {
    width: var(--contentWidth);
    margin: 0 auto;
    .left {
      float: left;
      display: flex;
      .brand {
        font-weight: 1000;
        font-size: 26px;
        margin-top: 4px;
        margin-right: 20px;
        position: relative;
        .brand-r {
          font-size: 8px;
          position: absolute;
          top: 6px;
          right: -8px;
        }
      }
      .name {
        font-size: 14px;
        letter-spacing: 3px;
        line-height: 50px;
      }
    }
    .right {
      float: right;
      font-size: 12px;
      letter-spacing: 2px;
      line-height: 48px;
      a {
        color: #cdcec7;
        margin-right: 30px;
        text-decoration:underline #fff 1px;
        &:hover {
          color: $color-white;
        }
      }
      .old-s {
        border-right: 1px solid #667075;
        padding-right: 18px;
      }
      .code-text {
        cursor: pointer;
        margin-right: 30px;
        color: $color-white;
        position: relative;
        i {
          font-size: 26px;
          position: absolute;
          top: -5px;
          left: -26px;
        }
        .qrcodeBox {
          --bColor:rgba(0, 0, 0, 0.2);
          position: absolute;
          border: 2px solid var(--bColor);
          background-color: $color-white;
          bottom: 50px;
          left: -40px;
          z-index: 100;
          padding: 15px;
          border-radius: 8px;
          line-height: 0;
          box-shadow: 0 0 12px 5px var(--bColor); // 修改阴影向四周扩散
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/common/footer.vue